(function () {
    'use strict';

    angular
        .module('app')
        .service('TestMerge', TestMergeFactory);

    TestMergeFactory.$inject = ['$window', 'DocMergeService', 'DialogService'];

    function TestMergeFactory($window, DocMergeService, DialogService) {
        /**
         * @constructor
         */
        function TestMerge() {
            var _self = this;
            this.testMergeResult = null;
            this.runTestMerge = runTestMerge;


            /**
             * Prompt the user for entity selection for a test merge, then run a test merge.
             *
             * @param {DocumentTemplate} documentTemplate
             * @returns {Promise} A promise resolved if a test merge was performed successfully
             */
            function runTestMerge(documentTemplate) {
                if (!_.isNil(documentTemplate.data.EntityTemplateId) && documentTemplate.data.EntityTemplateId !== '') {
                    return DialogService.show({
                        locals: { entityTemplateId: documentTemplate.data.EntityTemplateId },
                        controller: 'DocumentTemplateTestMerge',
                        controllerAs: 'vm',
                        templateUrl: 'app/documenttemplate/testmerge/document-template-test-merge.tmpl.html'
                    }).then(conductTestMergeOk);
                } else {
                    return conductTestMergeOk(null);
                }

                function conductTestMergeOk(entityId) {
                    var file;
                    var fileBlob;

                    switch (documentTemplate.fileDetails.Mode) {
                        case 'doc':
                        case 'docx':
                        case 'pdf':
                            fileBlob = documentTemplate.fileDetails.File;
                            break;
                        case 'html':
                            fileBlob = new Blob([documentTemplate.fileDetails.Html]);
                            break;
                        case 'txt':
                            fileBlob = new Blob([documentTemplate.fileDetails.Txt]);
                            break;
                    }

                    var documentTemplateMergeFields = {
                        Name: documentTemplate.data.Name,
                        Description: documentTemplate.data.Description
                    };
                    if (!_.isNil(documentTemplate.data.EntityTemplateId) && documentTemplate.data.EntityTemplateId !== '')
                        documentTemplateMergeFields.EntityTemplateId = documentTemplate.data.EntityTemplateId;

                    return DocMergeService.testMerge(entityId, fileBlob, documentTemplate.fileDetails.Mode, documentTemplate.data.OutputFormat, documentTemplate.data.AdvancedSettings,
                        documentTemplate.data.FileName, documentTemplateMergeFields)
                        .then(testMergeOk, testMergeError);

                    function testMergeOk(mergeResult) {
                        if (documentTemplate.data.OutputFormat.toLowerCase() === 'html') {
                            DialogService.show({
                                locals: { mergeResult: mergeResult.Data, format: 'html' },
                                controller: 'ShowTestMergeResult',
                                controllerAs: 'vm',
                                templateUrl: 'app/documenttemplate/testmerge/show-test-merge-result.tmpl.html'
                            });
                        } else if (documentTemplate.data.OutputFormat.toLowerCase() === 'txt') {
                            DialogService.show({
                                locals: { mergeResult: mergeResult.Data, format: 'txt' },
                                controller: 'ShowTestMergeResult',
                                controllerAs: 'vm',
                                templateUrl: 'app/documenttemplate/testmerge/show-test-merge-result.tmpl.html'
                            });
                        } else {
                            var resultBlob = new Blob([mergeResult.Data]);
                            $window.saveAs(resultBlob, mergeResult.FileName);
                        }

                        return mergeResult;
                    }

                    function testMergeError(response) {
                        DialogService.error("Error running test merge", response);
                    }
                }
            }
        }

        TestMerge.prototype = {};
        TestMerge.prototype.constructor = TestMerge;

        return TestMerge;
    }
})();